import React from "react";
import "./App.css";
import SortingVisualizer from "./Visualizer/SortingVisualizer";
// import “bootstrap/dist/bootstrap.min.css”;

function App() {
  return (
    <div className="App">
      <SortingVisualizer />
    </div>
  );
}

export default App;
